import { Link } from "react-router-dom";
import {
    ArrowUpRight,
    Waves,
    Drum,
    Timer,
    Mic,
    Search,
	Music2
} from "lucide-react";

const TOOLS = [
    {
        title: "Tanpura",
        desc: "Continuous drone for daily riyaaz.",
        icon: Waves,
        to: "/tanpura",
    },
    {
        title: "Tabla",
        desc: "Practice popular Hindustani taals.",
        icon: Drum,
        to: "/taals",
    },
    {
        title: "Metronome",
        desc: "Improve timing and rhythm.",
        icon: Timer,
        to: "/metronome",
    },
    {
        title: "Flute Tuner",
        desc: "Tune your bansuri accurately.",
        icon: Mic,
        to: "/tuner",
    },
    {
        title: "Scale Studio",
        desc: "Detect and Change the scale (Sa) of any audio.",
        icon: Search,
        to: "/scale-finder",
    },
	
{
    title: "Practice Track",
    desc: "Generate Karaoke Tracks.",
    icon: Music2,
     to: "/practice-track",
},
];

export default function Landing() {

    return (

        <div data-testid="landing-page">

            <section className="relative overflow-hidden">

                <div className="absolute inset-0 schematic opacity-20 pointer-events-none" />

                <div className="max-w-7xl mx-auto px-6 lg:px-10 py-10 lg:py-12">

                    <div className="text-center">

                        <div className="inline-flex items-center gap-3 text-xs uppercase tracking-[0.3em] text-muted-foreground mb-8">

                            <span className="w-10 h-px bg-primary"></span>

                            DAILY PRACTICE FOR HINDUSTANI MUSICIANS

                            <span className="w-10 h-px bg-primary"></span>

                        </div>

                        <h1 className="font-sans font-extrabold text-4xl md:text-5xl lg:text-6xl leading-tight">

                            Daily Riyaaz.

                            <br />

                            <span className="text-primary">

                                Timeless Music.

                            </span>

                        </h1>

                        <p className="mt-2 mb-2 text-base text-muted-foreground">

                            Everything you need for daily practice.

                            <br /><br />

                            Tanpura • Tabla • Metronome • Scale Finder • Flute Tuner

                            <br /><br />

                                                   </p>

                 

                    </div>

                  <div className="flex items-center mt-2 mb-4">

                        <div className="flex-1 h-px bg-border"></div>

                        <span className="px-6 text-xs uppercase tracking-[0.35em] text-muted-foreground">

                            KUNDAN FLUTES

                        </span>

                        <div className="flex-1 h-px bg-border"></div>

                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6">
					
					
					                        {TOOLS.map((tool) => {

                            const Icon = tool.icon;

                            return (

                                <Link
                                    key={tool.title}
                                    to={tool.to}
                                    className="riyaaz-card rounded-2xl border border-border bg-card p-4 hover:border-primary hover:-translate-y-1 transition-all duration-300"
                                >

                                    <div className="w-12 h-12 rounded-xl bg-primary/10 flex items-center justify-center mb-2">

                                        <Icon
                                            size={24}
                                            className="text-primary"
                                        />

                                    </div>

                                    <h3 className="text-lg font-bold mb-2">

                                        {tool.title}

                                    </h3>

                                    <p className="text-muted-foreground leading-6">

                                        {tool.desc}

                                    </p>

                                    <div className="mt-2 flex items-center text-primary font-semibold">

                                        Open

                                        <ArrowUpRight
                                            size={18}
                                            className="ml-2"
                                        />

                                    </div>

                                </Link>

                            );

                        })}

                    </div>

                    <div className="mt-16 text-center">

                        <p className="text-muted-foreground">

                            Found a bug or have a feature suggestion?

                        </p>

                        <a
                            href="mailto:kundanflutes@gmail.com"
                            className="mt-2 inline-block text-primary font-semibold hover:underline"
                        >
                            kundanflutes@gmail.com
                        </a>

                    </div>

                </div>

            </section>

        </div>

    );

}